import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + ACADEMIA PRO',
  description: '6 tomos + 6 bonos + Academia Pro™ (cobro, captación y negocio)',
  originalPrice: '$43.990',
  price: '$27.990',
  ctaText: '→ QUIERO EL PACK COMPLETO',
  ctaHref: 'https://www.profepack.com/cart/48185437094144:1',
  isFeatured: true,
  savings: 'AHORRÁS $16.000'
}, {
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK TENIS LISTO',
  description: '6 tomos + 6 bonos',
  originalPrice: '$34.990',
  price: '$19.990',
  ctaText: '→ QUIERO EL MEGAPACK',
  ctaHref: 'https://www.profepack.com/cart/48185437094144:1'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-156">
      <div className="max-w-xl mx-auto" data-id="element-157">
        {/* Header */}
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-2" data-id="element-158">
          Elegí tu <span className="text-[#00B4D8]" data-id="element-159">plan:</span>
        </h2>
        <p className="text-gray-400 text-center text-xs sm:text-sm mb-5 sm:mb-8" data-id="element-160">
          Ambos incluyen los 6 bonos estratégicos
        </p>

        {/* Options */}
        <div className="space-y-3 mb-5 sm:mb-6" data-id="element-161">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`relative w-full text-left rounded-xl p-4 sm:p-5 transition-all ${isFeatured && isSelected ? 'border-2 border-[#00B4D8] bg-[#000d1a] shadow-[0_0_30px_rgba(0,180,216,0.2)]' : isFeatured ? 'border-2 border-[#00B4D8]/50 bg-[#000d1a]' : isSelected ? 'border-2 border-[#00B4D8] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-162">
                {/* Featured ribbon */}
                {isFeatured && <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-163">
                    <span className="bg-[#00B4D8] text-black text-[10px] sm:text-xs font-black px-3 py-0.5 rounded-full whitespace-nowrap" data-id="element-164">
                      ⭐ MÁS ELEGIDO POR PROFES
                    </span>
                  </div>}

                <div className="flex items-center gap-3" data-id="element-165">
                  {/* Radio */}
                  <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#00B4D8]' : 'border-white/30'}`} data-id="element-166">
                    {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-[#00B4D8]" data-id="element-167" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-168">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-169">
                      <span className="text-base" data-id="element-170">{option.emoji}</span>
                      <span className="text-white font-black text-sm sm:text-base" data-id="element-171">
                        {option.title}
                      </span>
                    </div>
                    <p className="text-gray-400 text-xs mt-0.5" data-id="element-172">
                      {option.description}
                    </p>
                    {option.savings && <span className="inline-block mt-1.5 bg-[#00B4D8]/15 text-[#00B4D8] text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded-full border border-[#00B4D8]/30" data-id="element-173">
                        {option.savings}
                      </span>}
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-174">
                    <div className="text-gray-500 line-through text-xs" data-id="element-175">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-xl sm:text-2xl ${isFeatured ? 'text-[#00B4D8]' : 'text-white'}`} data-id="element-176">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Urgency mini countdown */}
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-177">
          <span className="text-[#FF0000] text-xs font-bold" data-id="element-178">
            🔥 Este precio se va en
          </span>
          <CountdownTimer size="sm" blinking={false} data-id="element-179" />
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-green-pulse block w-full text-center bg-[#00B4D8] font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl hover:bg-[#38BDF8] transition-colors text-white" data-id="element-180">
          {selectedOption.ctaText}
        </a>

        {/* Risk reversal */}
        <p className="text-center text-xs sm:text-sm mt-3 text-white font-semibold" data-id="element-181">
          🛡️ Si no te sirve, te devolvemos el 100% en 7 días. Sin preguntas.
        </p>

        {/* Social proof */}
        <p className="text-gray-400 text-[11px] sm:text-xs text-center mt-2 italic" data-id="element-182">
          12 profes compraron en las últimas 2 horas
        </p>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-[11px] sm:text-xs text-gray-400 mt-5 pt-4 border-t border-white/5" data-id="element-183">
          <span data-id="element-184">🔒 Pago seguro</span>
          <span data-id="element-185">⚡ Acceso en 5 min</span>
          <span data-id="element-186">💳 Mercado Pago · Tarjeta · Transferencia</span>
        </div>
      </div>
    </section>;
}